import { Translation, TranslocoModule, TranslocoService, provideTransloco } from "@jsverse/transloco";
import { APP_INITIALIZER, NgModule, isDevMode } from "@angular/core";
import { TranslocoHttpLoader } from "./transloco.http-loader";

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: [
                    {
                        id: "pt-BR",
                        label: "Português",
                    },
                ],

                defaultLang: "pt-BR",
                fallbackLang: "pt-BR",
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader,
        }),
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide: APP_INITIALIZER,
            deps: [TranslocoService],
            useFactory: (translocoService: TranslocoService) => (): Promise<Translation> => {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return translocoService.load(defaultLang).toPromise();
            },
            multi: true,
        },
    ],
})
export class TranslocoCoreModule {}
